import styled from 'styled-components';
import type { ColorActiveFilter } from 'autogen/swagger/all';
import FilterTag from 'components/Filter/components/FilterTag/FilterTag';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import useFilters from '../../../shared/hooks/useFilters';

/* #region styles */
const ColorPreview = styled.div<{ hexColor?: string }>`
    width: 12px;
    height: 12px;
    background-color: ${({ hexColor }) => hexColor || 'transparent'};
`;

const MultiColorPreview = styled.div`
    width: 12px;
    height: 12px;
    background-image: conic-gradient(
        from 270deg at 51% 49%,
        #0e8328 25%,
        #f868e1 25%,
        #f868e1 50%,
        #011ba2 50%,
        #011ba2 75%,
        #f0d444 75%,
        #f0d444 100%
    );
`;
/* #endregion */

export default function ColorActiveFilterOption({
    model: { displayValue, queryStringName, value, hexColor }
}: {
    model: ColorActiveFilter;
}) {
    const { removeFilterByValue } = useFilters();

    const isMultiColor = displayValue === 'Multi';
    const colorIcon = isMultiColor ? <MultiColorPreview /> : <ColorPreview hexColor={hexColor} />;

    return (
        <FilterTag onClick={() => removeFilterByValue(queryStringName, value)}>
            <WithIcon icon={colorIcon}>
                <span>{displayValue}</span>
            </WithIcon>
        </FilterTag>
    );
}
